import { getUrl } from '../config';
import { Global, css } from "@emotion/react";

const isSubFrame = typeof window !== 'undefined' && window.self !== window.top;

const GlobalStyle = (props) => (
  <Global
    {...props}
    styles={css`
      html,
      body,
      #root {
        height: 100%;
      }

      body {
        margin: 0;
      }

      .MuiCardHeader-action .MuiIconButton-root {
        padding: 4px;
        width: 28px;
        height: 28px;
      }

      body > iframe {
        pointer-events: none;
      }

      ${isSubFrame && css`
        html::-webkit-scrollbar,
        body::-webkit-scrollbar,
        div::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }
        html, body, div {
          -ms-overflow-style: none !important;
          scrollbar-width: none !important;
        }
      `}
    `}
  />
);

export default GlobalStyle;
